import { Pipe, PipeTransform } from '@angular/core';
import { NormalizerHelper } from 'src/app/core/helpers/normalizer.helper';
import { NullSafe } from 'src/app/core/types/null-safe.type';

@Pipe({
  name: 'dateTime',
})
export class DateTimePipe implements PipeTransform {
  transform(value: NullSafe<Date | string>, mask: string = 'dd/MM/yyyy - 00:00:00'): string {
    return NormalizerHelper.dateTime(value, mask);
  }
}
